import {AxiosResponse } from 'axios';

import apiClient from './client';
import { PageResultDto } from 'interfaces/page';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { Service } from '../interfaces/service';
import { Price } from '../interfaces/price';

interface ServiceServices {
  searchServices(queryParams?: any): Promise<PageResultDto<Service>>
  getService(id: string): Promise<Service>
  createService(postData: any): Promise<AxiosResponse<any>>
  editService(id: string, postData: any): Promise<AxiosResponse<any>>
  calculateAmount(postData: Price): Promise<Price>
}

const endpoints = {
  searchServices: '/services',
  getService: (id: string) => `/services/${id}`,
  createService: '/services',
  editService: (id: string) => `/services/${id}`,
  calculateAmount: '/services/amount/calculate',
}

export const serviceServices: ServiceServices = {
  searchServices: async (queryParams?: any): Promise<PageResultDto<Service>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<Service>>> = await apiClient.get(endpoints.searchServices, {params: {...queryParams}});

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  getService: async (id: string): Promise<Service> => {
    const response: AxiosResponse<ApiResponseDto<Service>> = await apiClient.get(endpoints.getService(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  createService: async (postData: any): Promise<AxiosResponse<any>> => {
    return apiClient.post(endpoints.createService, postData);
  },
  calculateAmount: async (postData: Price): Promise<Price> => {
    const response: AxiosResponse<ApiResponseDto<Price>> = await apiClient.post(endpoints.calculateAmount, postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  editService: async (id: string, postData: any): Promise<AxiosResponse<any>> => {
    return apiClient.put(endpoints.editService(id), postData);
  },
}
